videoOverlayIsVisible = false;
videoOverlayPosterURL = "";
videoOverlayVideoWebmURL = "";
videoOverlayVideoMp4URL = "";

function showVideo() {
	//console.log("SHOWVIDEO");
	// TOGGLE FLAG
	videoOverlayIsVisible = true;
	// UPDATE SRC
	jQuery(".videoOverlay_video").attr("poster",videoOverlayPosterURL);
	jQuery(".videoOverlay_video_Webm").attr("src",videoOverlayVideoWebmURL);
	jQuery(".videoOverlay_video_Mp4").attr("src",videoOverlayVideoMp4URL);
	jQuery(".videoOverlay_video").get(0).load();
	jQuery(".videoOverlay_video").get(0).play();
	// SHOW OVERLAY
	jQuery(".videoOverlay").css("display","block");
}

function hideVideo() {
	//console.log("HIDEVIDEO");
	// TOGGLE FLAG
	videoOverlayIsVisible = false;
	// DELETE SRC
	jQuery(".videoOverlay_video").get(0).pause();
	jQuery(".videoOverlay_video").attr("poster","");
	jQuery(".videoOverlay_video_Webm").attr("src","");
	jQuery(".videoOverlay_video_Mp4").attr("src","");
	videoOverlayPosterURL = "";
	videoOverlayVideoWebmURL = "";
	videoOverlayVideoMp4URL = "";
	// HIDE OVERLAY
	jQuery(".videoOverlay").css("display","none");
}

function initVideoOverlayButtons() {
	// btPlayOverlayVideo__bt
	jQuery(".btPlayOverlayVideo__bt").click(function(event){
		event.preventDefault();
		videoOverlayPosterURL = jQuery(this).attr("data-src-poster");
		videoOverlayVideoWebmURL = jQuery(this).attr("data-src-webm");
		videoOverlayVideoMp4URL = jQuery(this).attr("data-src-mp4");
		if(videoOverlayIsVisible) {
			hideVideo();
		} else {
			showVideo();
		}
	});
	// videoOverlay__closeBt
	jQuery(".videoOverlay__closeBt").click(function(event) {
		event.preventDefault();
		hideVideo();
	});
}

(function(w, d){
	initVideoOverlayButtons();
}(window, document));